<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Criterion</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <input-field :inlineField="true" label="Audience" type="text" :toolTip="'Audience Name'" :modelValue="audience?.audience_name" :editable="false"></input-field>
            <input-field :inlineField="true" label="Data Environment" type="text" :toolTip="'Data Environment'" :modelValue="audience?.audsum_data_environment" :editable="false"></input-field>
            <input-field :inlineField="true" label="Dataset" type="text" :toolTip="'Dataset'" :modelValue="audience?.audsum_dataset" :editable="false"></input-field>
            <input-field :inlineField="true" label="Criterion" type="json" :inputType="'json'" :toolTip="'Criterion Built'" :modelValue="criterion" :editable="false"></input-field>
        </div>
    </div>
</template>

<script>
import InputField from "../../components/InputField.vue";
export default {
    components: { InputField },
    data() {
        return {
            criterion: null,
            audience: null,
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "ViewCriterion",
    beforeMount() {
        this.criterion = JSON.stringify(this.modalData?.criterion, null, 2);
        this.audience = this.modalData?.audience;
    },
};
</script>
<style scoped>
/* Override label width from col-sm-4 to col-sm-3 */
::v-deep(.form-group.inline-field label.col-sm-4) {
    flex: 0 0 25% !important;
    max-width: 25% !important;
}

/* Override input field width from col-sm-8 to col-sm-9 to fill remaining space */
::v-deep(.form-group.inline-field .col-sm-8) {
    flex: 0 0 75% !important;
    max-width: 75% !important;
}
</style>